import React from 'react'
import { Text, StandardFieldLabel } from '@adc/ui-adc'
import { graph } from '@adc/constants'

export const radioOptions = [
  {
    label: (
      <StandardFieldLabel
        label='Buyer Who Intends to Live in the Property'
        elmId='homebuyer'
        subLabel='You are a buyer or their agent purchasing a property to use as a primary residence.'
      />
    ),
    value: graph.enums.FirstLookBuyerSelectionType.HOMEBUYER,
  },
  {
    label: (
      <StandardFieldLabel
        label='Entity Approved for First Look Properties'
        elmId='entity'
        subLabel={
          <Text size='tiny' color='grayMedium'>
            You are an employee or agent representing a government entity or
            non-profit. Learn More:{' '}
            <a href='/firstlook' target='_blank' rel='noreferrer'>
              View First Look FAQ’s
            </a>
          </Text>
        }
      />
    ),
    value: graph.enums.FirstLookBuyerSelectionType.ENTITY_APPROVED,
  },
  {
    label: (
      <StandardFieldLabel
        label='Investor'
        elmId='investor'
        subLabel='You are buying an investment property or second home.'
      />
    ),
    value: graph.enums.FirstLookBuyerSelectionType.INVESTOR,
  },
]

export const californiaSpecialTreatmentRadioOptions = [
  {
    label: (
      <StandardFieldLabel
        label='Buyer Who Intends to Live in the Property'
        elmId='homebuyer'
        subLabel='You are purchasing a property to use as a primary residence'
      />
    ),
    value: graph.enums.FirstLookBuyerSelectionType.HOMEBUYER,
  },
  {
    label: (
      <StandardFieldLabel
        label='Entity Approved for First Look Properties'
        elmId='entity'
        subLabel={
          <Text size='tiny' color='grayMedium'>
            You are purchasing as a qualified governmental entity or non-profit.
            Learn More:{' '}
            <a href='/firstlook' target='_blank' rel='noreferrer'>
              View First Look FAQ’s
            </a>
          </Text>
        }
      />
    ),
    value: graph.enums.FirstLookBuyerSelectionType.ENTITY_APPROVED,
  },
  {
    label: (
      <StandardFieldLabel
        label='Investor'
        elmId='investor'
        subLabel='You are buying an investment property or second home.'
      />
    ),
    value: graph.enums.FirstLookBuyerSelectionType.INVESTOR,
  },
]

export const investorSaveRadioOptions = [
  {
    label: (
      <StandardFieldLabel
        label='Yes, notify me when bidding becomes available to investors.'
        elmId='save'
      />
    ),
    value: true,
  },
  {
    label: (
      <StandardFieldLabel
        label='No, remove it from my saved properties.'
        elmId='unsave'
      />
    ),
    value: false,
  },
]
